import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const reorderFulfillmentOptionsSelector = createSelector(testTargetOffersSelector, offers => offers.reorderFulfillmentOptions || Empty.Object);

export { reorderFulfillmentOptionsSelector };
